<template>
  <div class="my-home-box show-flex-box-r show-flex-center">
    <dl class="show-flex-box-r">
      <dt class="my-home-sidebar-box">
        <my-sidebar-nav></my-sidebar-nav>
      </dt>
      <dd class="my-home-content-box">
        <router-view :key="$route.fullPath"></router-view>
        <!-- <router-view /> -->
      </dd>
    </dl>
  </div>
</template>

<script>
import regex from "@/filter/regex";
import mySidebarNav from "@/views/my/nav/my_sidebar_nav";
// import {LoginUser} from "@/model/login_user.js";

export default {
  name: "myHome",
  data() {
    return {};
  },
  components: {
    mySidebarNav
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped>
.my-home-box{
  width:100%;
  padding:20px 0px 80px 0px;
  background: #faf9f9;
  >dl{
    width: 1200px ;
    >dt{
      width: 240px;
      margin-right: 20px;
      flex-shrink: 0;
    }
    >dd{
      flex-grow: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/my_home.vue